// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import CarouselController from "./carousel_controller"
application.register("carousel", CarouselController)

import HamburgerController from "./hamburger_controller"
application.register("hamburger", HamburgerController)

import KeyboardController from "./keyboard_controller"
application.register("keyboard", KeyboardController)

import LightboxController from "./lightbox_controller"
application.register("lightbox", LightboxController)

import NavigationController from "./navigation_controller"
application.register("navigation", NavigationController)

import ListingPhotosController from "./listing_photos_controller"
application.register("listing-photos", ListingPhotosController)

import TurnstileController from "./turnstile_controller"
application.register("turnstile", TurnstileController)

import ViewModeController from "./view_mode_controller"
application.register("view-mode", ViewModeController)
